import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './ar.json';
import en from './en.json';
import fr from './fr.json';
import es from './es.json';
import de from './de.json';
import tr from './tr.json';
import hi from './hi.json';
import fa from './fa.json';
import ur from './ur.json';
import zh from './zh.json';

const resources = {
  ar: { translation: ar },
  en: { translation: en },
  fr: { translation: fr },
  es: { translation: es },
  de: { translation: de },
  tr: { translation: tr },
  hi: { translation: hi },
  fa: { translation: fa },
  ur: { translation: ur },
  zh: { translation: zh },
};

const getBrowserLanguage = () => {
  const browserLang = navigator.language.split('-')[0];
  return resources[browserLang] ? browserLang : 'ar';
};

const savedLanguage = localStorage.getItem('language') || getBrowserLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Set initial direction and lang attribute
document.documentElement.lang = savedLanguage;
document.documentElement.dir = savedLanguage === 'ar' || savedLanguage === 'fa' || savedLanguage === 'ur' ? 'rtl' : 'ltr';

// Listen for language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' || lng === 'fa' || lng === 'ur' ? 'rtl' : 'ltr';
  localStorage.setItem('language', lng);
});

export default i18n;
